<script setup lang="ts">
defineProps<{
  data: HighlightedComponentType;
}>();
</script>

<template>
  <section class="flex w-full flex-col items-center gap-4 bg-green-30 pt-8 pb-24">
    <h2 class="mt-[2.4rem] -mb-2 text-base text-green-50 uppercase">
      Aktuelt
    </h2>
    <h3 class="font-headline text-3xl text-green-50" v-text="data.title" />
    <div class="relative">
      <UiStripesArticles :articles="data.articles" :range="[0, 2]" />

      <UiGraphicsHighlight
        aria-hidden="true"
        class="stamp absolute z-10 hidden rotate-on-scroll sm:block"
      />
    </div>
  </section>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

.stamp {
  @media screen and (min-width: theme("screens.sm")) {
    bottom: -2.5rem;
    right: 8rem;
  }

  @media screen and (min-width: theme("screens.tablet")) {
    bottom: -3rem;
    right: -2rem;
  }
}
</style>
